import React, {useCallback, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import AuthService from '../core/_requests'
import useCancelToken from '../../../../_gori/hooks/UseCancelToken'
import {Button} from '../../../../_gori/partials/widgets'
import {KTSVG, StorageHelpers} from '../../../../_gori/helpers'
import {InputInternationalPhoneFormik} from '../../../../_gori/partials/widgets/form/InputInternationalPhoneFormik'

type Props = {
  show: boolean
  handleClose: () => void
  formik: any
  checkChangePhone: (any) => void
  setVerifiedPhone: React.Dispatch<React.SetStateAction<boolean>>
  errorMessageVerifiedPhone: boolean
  setErrorMessageVerifiedPhone: React.Dispatch<React.SetStateAction<boolean>>
  setShowModal: React.Dispatch<
    React.SetStateAction<{
      verify_phone: boolean
      identity_verification: boolean
    }>
  >
  setDataModal: React.Dispatch<
    React.SetStateAction<{
      verify_phone: any
      identity_verification: any
    }>
  >
  title?: string
}

const IdentityVerificationModal: React.FC<Props> = ({
  show,
  handleClose,
  formik,
  checkChangePhone,
  setVerifiedPhone,
  errorMessageVerifiedPhone,
  setErrorMessageVerifiedPhone,
  setShowModal,
  setDataModal,
  title = 'IDENTITY_VERIFICATION',
}) => {
  const intl = useIntl()
  const {newCancelToken} = useCancelToken()
  const [isSendingOTP, setIsSendingOTP] = useState<boolean>(false)
  const [errorMessage, setErrorMessage] = useState<string>('')

  const sendSmsOTP = useCallback(async () => {
    setIsSendingOTP(true)
    const payload = {
      phone: formik.values.phone,
    }
    const config = {cancelToken: newCancelToken()}
    await AuthService.sendOTP(payload, config)
      .then(async (response) => {
        setErrorMessage('')
        if (response.whitelisted) {
          setVerifiedPhone(true)
          setErrorMessageVerifiedPhone(false)
          StorageHelpers.setItemLocalStorage('PHONE_VERIFIED', payload.phone)
        }

        setDataModal((prev) => ({...prev, verify_phone: response}))
        setShowModal((prev) => ({
          ...prev,
          identity_verification: false,
          verify_phone: true,
        }))
      })
      .catch((error: any) => {
        let err = error?.response?.data?.error?.message
        setErrorMessageVerifiedPhone(true)
        setErrorMessage(err)
      })
      .finally(() => {
        setIsSendingOTP(false)
      })
  }, [
    newCancelToken,
    formik.values.phone,
    setErrorMessageVerifiedPhone,
    setDataModal,
    setShowModal,
    setVerifiedPhone,
  ])

  const isCloseDisabled =
    !formik.values.phone || !formik.values.phone.trim() || formik.isSubmitting || isSendingOTP

  return (
    <>
      <Modal
        id='gori_modal_identity_verification'
        tabIndex={-1}
        centered
        dialogClassName='modal-size-md h-auto'
        contentClassName='modal-padding'
        show={show}
        backdrop='static'
        onHide={handleClose}
        scrollable={false}
      >
        <Modal.Header closeButton>
          <Modal.Title bsPrefix={'fw-bolder fs-1'}>{intl.formatMessage({id: title})}</Modal.Title>
        </Modal.Header>
        <Modal.Body className='vh-75'>
          <div className='mx-13'>
            <h2 className='text-xl font-semibold mb-4 text-center'>
              {intl.formatMessage({id: 'ENTER_YOUR_PHONE_NUMBER'})}
            </h2>
            <div className='justify-content-center d-flex mb-7'>
              <p className='fs-7 m-0'>{intl.formatMessage({id: 'PLEASE_VERIFY_YOUR_PHONE'})}</p>
            </div>

            <div className='row fv-row mb-7 fv-plugins-icon-container'>
              <div className='col-xl-12 px-10'>
                <InputInternationalPhoneFormik
                  labelClassName={'form-label fw-bolder text-dark fs-6 required'}
                  className='w-auto rounded-5'
                  size='lg'
                  required={true}
                  formik={formik}
                  name='phone'
                  onChange={(value) => {
                    setErrorMessage('')
                    checkChangePhone(value)
                  }}
                />
              </div>
            </div>

            {!errorMessage && (
              <div className='mt-7'>
                <div className='d-flex w-100 justify-content-center px-7'>
                  <span className='me-2 fs-7'>
                    {intl.formatMessage({id: 'AGREE_TO_RECEIVE_MESSAGING'})}
                  </span>
                </div>
              </div>
            )}
            {errorMessage && (
              <div className='mt-7'>
                <div className='d-flex w-100 justify-content-center px-10'>
                  <KTSVG path='/media/gori/invalid.svg' className='svg-icon-4 me-1' />
                  <span className='me-2 fs-7 text-danger'>{errorMessage}</span>
                </div>
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className='d-flex justify-content-end'>
            <Button
              className='btn btn-advanced-secondary me-2'
              label={intl.formatMessage({id: 'CLOSE'})}
              loadingText={intl.formatMessage({id: 'CLOSE'})}
              event={handleClose}
              disabled={isCloseDisabled}
            />
            <Button
              className='btn btn-advanced-primary me-2'
              label={intl.formatMessage({id: 'SEND_CODE'})}
              loadingText={intl.formatMessage({id: 'SEND_CODE'})}
              event={sendSmsOTP}
              disabled={isCloseDisabled}
              loading={formik.isSubmitting || isSendingOTP}
            />
          </div>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export {IdentityVerificationModal}
